export const uploadErrorType = {
  GET_SIGN_ERROR: 1,
  OSS_ERROR: 2,
  ADMIN_ERROR: 3
}

export const uploadStatus = {
  SUCCESS: '上传成功',
  FAILED: '上传失败',
  COMPLETED: '上传完成',
  UPLOADING: '上传'
}

export const fileType = {
  PICTURE: 1,
  VIDEO: 2,
  AUDIO: 3,
  PDF: 4,
  WORD: 5,
  EXCEL: 6,
  PPT: 7
}

export const fileTypeList = [
  {
    value: 1,
    type: "picture",
    extensions: [
      "bmp",
      "jpg",
      "jpeg",
      "png",
      "tif",
      "gif",
      "pcx",
      "tga",
      "exif",
      "fpx",
      "svg",
      "psd",
      "cdr",
      "pcd",
      "dxf",
      "ufo",
      "eps",
      "ai",
      "raw",
      "wmf",
      "webp",
      "avif"
    ]
  },
  {
    value: 2,
    type: "video",
    extensions: [
      "wmv",
      "asf",
      "asxrm",
      "rmvb",
      "mp4",
      "3gp",
      "mov",
      "m4v",
      "avi",
      "dat",
      "mkv",
      "flv",
      "vob"
    ]
  },
  {
    value: 3,
    type: "audio",
    extensions: [
      "cd",
      "wave",
      "aiff",
      "mpeg",
      "mp3",
      "mpeg-4",
      "midi",
      "wma",
      "realaudio",
      "vqf",
      "oggvorbis",
      "amr",
      "ape",
      "flac",
      "aac"
    ]
  },
  {
    value: 4,
    type: "pdf",
    extensions: [
      "pdf"
    ]
  },
  {
    value: 5,
    type: "word",
    extensions: [
      "doc",
      "docx"
    ]
  },
  {
    value: 6,
    type: "excel",
    extensions: [
      "xls",
      "xlsx"
    ]
  },
  {
    value: 7,
    type: "ppt",
    extensions: [
      "ppt",
      "pptx",
      "pps"
    ]
  },
  {
    value: 8,
    type: "other",
    extensions: []
  },
  {
    value: 9,
    type: "txt",
    extensions: ["txt"]
  },
  {
    type: "forbidden",
    extensions: [
      "css",
      "js",
      "java",
      "python",
      "php",
      "c"
    ]
  }
]